import { lazy, PureComponent, Suspense } from 'react';

import { type RouteComponentProps } from 'react-router'

const DevelopmentChunk = lazy(() =>
  import(
    /* webpackChunkName: 'Development' */ '../containers/__DEVELOPMENT__/Development'
  ).then(({ Development }) => ({ default: Development }))
)

export class DevelopmentPage extends PureComponent<RouteComponentProps> {
  render() {
    return (
      <Suspense fallback={null}>
        <DevelopmentChunk {...this.props} />
      </Suspense>
    );
  }
}
